import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as globalConstant from '../../global_constant';
import { BlogCategoryService } from 'src/app/services/Blogcategory.service';
import { Title, Meta } from '@angular/platform-browser';
import { SharedModule } from '../../share/shared.module';
import { isPlatformBrowser } from '@angular/common';


@Component({
  selector: 'app-category-blog',
  standalone: true,
  imports: [
    SharedModule,
  ],
  templateUrl: './category-blog.component.html',
  styleUrls: ['./category-blog.component.css']
})
export class CategoryBlogComponent implements OnInit {

  webUrl = globalConstant.WEBSITE_URL;
  category_data: any;
  category_image_url = '';

  selected_date = '';
  other_data: any;
  extraCategoryData: any = []
  slug = '';
  show_the_tabs = false
  itself: any;
  isBrowser: boolean;
  constructor(
    private categoryDetail: BlogCategoryService,
    public router: Router,
    @Inject(PLATFORM_ID) platformId: Object,
    private titleService: Title,
    private metaService: Meta,
    private route: ActivatedRoute
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {

      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }


  ngOnInit() {

    this.slug = this.route.snapshot.params.slug;
    // const formData = new FormData();
    // formData.append('slug',this.slug);
    let requestBoady = { 'slug': this.slug }
    this.categoryDetail.get_categoriesdetail(requestBoady).subscribe(res => {
      if (res.response == "success") {
        this.itself = res.category;
        this.category_data = res.records;

        this.extraCategoryData = res.top_ten_items;
        this.other_data = res.other_categories;
        this.category_image_url = res.image_url;
        this.titleService.setTitle(this.itself.name + globalConstant.SITE_TITLE_SEPARATOR + globalConstant.SITE_TITLE);
      }
    });

  }
  navigateToPageUrl(url, slug) {
    if (url && url.trim() != '') {
      let pageUrl = url.replace(this.webUrl, "");
      let urlResult = this.parseNavigateUrl(pageUrl);
      this.router.navigate(['/' + urlResult['url']], { queryParams: urlResult['obj'] });
    } else if (slug && slug.trim() != '') {
      this.exp_detail(slug);
    }
  }
  exp_detail(slug, request_type = '') {
    //this.router.navigate(['/top-ten-category/'+this.slug], { queryParams: { date: this.selected_date , 'is_booking': this.is_booking } })
    this.router.navigate(['/top-ten-category/' + this.slug])
    setTimeout(() => {
      this.router.navigate(['/experiences/' + slug], { queryParams: { date: this.selected_date, 'request_type': request_type } })
    }, 10)
  }
  parseNavigateUrl(url) {
    var result = {};
    var urlArr = url?.split("?");

    var baseUrl = urlArr[0];
    var sPageURL = urlArr[1];
    var sURLVariables = sPageURL?.split('&');
    for (var i = 0; i < sURLVariables?.length; i++) {
      var sParameterName = sURLVariables[i]?.split('=');
      result[sParameterName[0]] = sParameterName[1];
    }
    return { 'url': baseUrl, 'obj': result };
  }
  addMetaTags() {

    if (this.category_data.seo_keywords != null && this.category_data.seo_keywords != '') {
      this.metaService.updateTag({ property: 'keywords', content: this.category_data.seo_keywords });
    }

    if (this.category_data.seo_description != null && this.category_data.seo_description != '') {
      this.metaService.updateTag({ property: 'description', content: this.category_data.seo_description });
    } else {
      this.metaService.updateTag({ property: 'description', content: this.category_data.name });
    }
  }
}

